import { SVGProps, Ref, forwardRef } from 'react';

export const IbsGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M14.5 0h-13A1.5 1.5 0 0 0 0 1.5v13A1.5 1.5 0 0 0 1.5 16h13a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0"
                fill="#919191"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.764 6.942h.342v2.116h-.342v.978h2.21v-.978h-.341V6.942h.341v-.978h-2.21zm6.08.976a.95.95 0 0 0 .553-.93c0-.526-.41-1.02-1.118-1.02H5.384v.978h.342v2.112h-.342v.978h3.091A1.125 1.125 0 0 0 9.53 8.892a1.02 1.02 0 0 0-.69-.958zM7.74 9.064h-.614V8.45h.614a.31.31 0 0 1 .307.307.303.303 0 0 1-.309.304zm-.616-1.538v-.584h.59a.297.297 0 0 1 .288.292.3.3 0 0 1-.292.294zm4.077-.087a.3.3 0 0 0 .206.089l.845-.002a1.255 1.255 0 0 1 1.275 1.242 1.27 1.27 0 0 1-1.27 1.268H9.944V8.77h1.27v.3h.613a.307.307 0 0 0 .217-.523.3.3 0 0 0-.217-.09h-.833a1.23 1.23 0 0 1-1.263-1.225c0-.797.622-1.265 1.415-1.265h2.104v1.26h-1.259v-.285h-.585a.295.295 0 0 0-.293.292.3.3 0 0 0 .087.205"
                fill="white"
            />
        </g>
    </svg>
));
IbsGrayscaleSize16Glyph.displayName = 'IbsGrayscaleSize16Glyph';
